import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_badge = _resolveComponent("q-badge");
    return (_openBlock(), _createBlock(_component_q_badge, {
        class: _normalizeClass(_ctx.badgeClass),
        style: _normalizeStyle(_ctx.style)
    }, {
        default: _withCtx(() => [
            _withDirectives(_createVNode(_component_q_icon, { name: _ctx.badgeIcon }, null, 8, ["name"]), [
                [_vShow, _ctx.badgeIcon]
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.badgeLabel), 1)
        ]),
        _: 1
    }, 8, ["class", "style"]));
}
